module.exports = __webpack_public_path__ + "static/media/ATMA-SPHERE CLASS D MONOBLOCKS.d3ae94a3.png";